import React, {Component} from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import {List, Map} from "immutable";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";

// Components
import ProductDetail from "./ProductDetail";
import ProductStock from './ProductStock';
import DeleteDialog from "../../../components/dialogs/DeleteDialog";

// Actions
import {changeProductStatus, getProduct, updateProduct, deleteProduct, cleanProducts} from "../../../actions/products";

class ProductTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabIndex: this.getSelectedIndex(),
            mode: 'view',
            canSubmit: false,
            newCategoryLabel: '',
            product_code: '',
            name: '',
            desc: '',
            category_labels: List([]),
            unit_of_measure: '',
            vat: '',
            to_buy: true,
            is_generic: false,
            suppliers: List([]),
            cost_prices: List([]),
            price_alert: false,
            price_alert_threshold: '',
            status: '',
            // modal
            modalIsOpen: false,
            modalType: null
        };

        this.getSelectedIndex = this.getSelectedIndex.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    componentDidMount() {
        const { productId } = this.props.match.params;

        this.props.getProduct(productId, {
            populateRefs: true
        });
    }

    componentDidUpdate(prevProps) {
        const { product: prevProduct } = prevProps;
        const { product } = this.props;

        if (product && product !== prevProduct) this.setProduct(product);
    }

    componentWillUnmount() {
        this.props.cleanProducts();
    }

    // Tab functions
    getSelectedIndex() {
        const {productId} = this.props.match.params;

        // Check if any child route is active. As last step, check if principal route is active to assign default tab index.
        switch (this.props.history.location.pathname) {
            case '/productos/' + productId + '/detalle':
                return 0;
            case '/productos/' + productId + '/stock':
                return 1;
            default:
                return 0;
        }
    }
    handleTabChange(index, lastIndex, event) {
        const {productId} = this.props.match.params;
        let route = '';

        switch (index) {
            case 0:
                route = '/productos/' + productId + '/detalle';
                break;
            case 1:
                route = '/productos/' + productId + '/stock';
                break;
            default:
                break;
        }

        this.props.history.push(route);
        this.setState({
            tabIndex: this.getSelectedIndex()
        });
    }

    // ProductDetail functions
    handleEditClick = () => {
        this.setState({
            mode: 'edit'
        });
    };
    handleCancelClick = () => {
        const { product } = this.props;

        this.setProduct(product);
        this.setState({
            mode: 'view'
        });
    };
    handleSaveClick = (productId, product) => {

        this.props.updateProduct(productId, product);
        this.setState({
            mode: 'view'
        });
    };
    onChangeInput = (inputName, inputValue) => {
        this.setState({
            [inputName]: inputValue
        }, this.validateProduct);
    };
    onChangeSuppliers = () => {
        const { suppliers } = this.state;

        if (!suppliers.some(supplier => supplier.get('is_default') === true)) {
            this.onChangeDefaultSupplier(false, 0)
        } else {
            this.validateProduct();
        }
    };
    onChangeSupplierReference = (i, supplier, reference) => {
        this.setState({
            suppliers: this.state.suppliers.set(i, supplier.merge({
                reference
            }))
        }, this.validateProduct);
    };
    onChangeDefaultSupplier = (defaultValue, i) => {
        let newSuppliers = List([]);

        this.state.suppliers.map( (supplier, j) => {
            const newDefault = j === i ? !defaultValue : defaultValue;

            return newSuppliers = newSuppliers.insert(newSuppliers.size, supplier.merge({ is_default: newDefault }));
        });
        this.setState({
            suppliers: newSuppliers
        }, this.validateProduct);
    };
    addSupplier = (supplier, name, supplier_code) => {
        this.setState({
            suppliers: this.state.suppliers.insert(this.state.suppliers.size, Map({
                supplier,
                name,
                supplier_code,
                reference: '',
                is_default: false
            }))
        }, this.onChangeSuppliers);
    };
    deleteSupplier = (i) => {
        this.setState({
            suppliers: this.state.suppliers.remove(i)
        }, this.onChangeSuppliers);
    };
    deleteSuppliers = () => {
        this.setState({
            suppliers: List([])
        });
    };
    addCategoryLabel = () => {
        const { category_labels, newCategoryLabel } = this.state;
        if (newCategoryLabel !== '') {
            this.setState({
                category_labels: category_labels.push(newCategoryLabel)
            }, () => this.setState({ newCategoryLabel: '' }));
        }
    };
    deleteCategoryLabel = (index) => {
        this.setState({
            category_labels: this.state.category_labels.delete(index)
        });
    };
    setProduct = (product) => {
        this.setState({
            product_code: product.get('product_code'),
            name: product.get('name'),
            desc: product.get('desc') || '',
            category_labels: product.get('category_labels'),
            unit_of_measure: product.get('unit_of_measure') || '',
            vat: product.get('vat'),
            to_buy: product.get('to_buy'),
            is_generic: product.get('is_generic'),
            suppliers: product.get('suppliers'),
            cost_prices: product.get('cost_prices'),
            price_alert: product.get('price_alert'),
            price_alert_threshold: product.get('price_alert_threshold') || '',
            status: product.get('status')
        }, () => this.validateProduct);
    };
    validateProduct = () => {
        if (
            this.state.product_code !== '' &&
            this.state.name !== '' &&
            this.state.vat !== '' &&
            this.state.to_buy !== '' &&
            this.state.is_generic !== ''
        ) {
            this.setState({
                canSubmit: true
            });
        } else {
            this.setState({
                canSubmit: false
            });
        }
    };

    // Modal handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false
        })
    };

    render() {
        const {productId} = this.props.match.params;
        // const {} = this.props;
        const {
            tabIndex,
            mode,
            canSubmit,
            newCategoryLabel,
            product_code,
            name,
            desc,
            category_labels,
            unit_of_measure,
            vat,
            to_buy,
            is_generic,
            suppliers,
            cost_prices,
            price_alert,
            price_alert_threshold,
            status
        } = this.state;

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'deleteDialog':
                    modal = {
                        width: 'medium',
                        title: 'Borrar producto',
                        body: (
                            <DeleteDialog
                                text={ this.props.product.get('product_code') }
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="delete"
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={ () => {
                                        this.props.deleteProduct(this.props.product.get('_id'));
                                        this.closeModal();
                                        this.props.history.push('/productos');
                                    }}
                                >
                                    {'Borrar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (

            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                Configuración
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/productos">Productos</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>{`[${product_code}] ${name}`}</strong>
                            </li>
                        </ol>
                    </div>
                    { tabIndex === 0
                        ? (
                            <div className="col d-flex align-items-center justify-content-end">
                                {mode === 'view'
                                    ? <div className="title-action">
                                        {
                                            this.props.product.get('can_delete')
                                                ? <button className="btn btn-danger" onClick={ () => this.openModal('deleteDialog') }>Borrar</button>
                                                : null
                                        }
                                        <button className="btn btn-custom" onClick={this.handleEditClick}>Editar</button>
                                    </div>
                                    : <div className="title-action">
                                        <button className="btn btn-cancel" onClick={this.handleCancelClick}>Cancelar</button>
                                        <button
                                            className="btn btn-primary"
                                            onClick={ () => this.handleSaveClick(productId, {
                                                product_code,
                                                name,
                                                desc,
                                                category_labels,
                                                unit_of_measure,
                                                vat,
                                                to_buy,
                                                is_generic,
                                                suppliers,
                                                price_alert,
                                                price_alert_threshold
                                            }) }
                                            disabled={!canSubmit}
                                        >Guardar
                                        </button>
                                    </div>
                                }
                            </div>
                        ) : ''
                    }
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="tabs-container">
                                <Tabs
                                    selectedIndex={tabIndex}
                                    onSelect={this.handleTabChange}
                                    selectedTabPanelClassName="active show"
                                >
                                    <TabList className="nav nav-tabs">
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 0})}>Detalle</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 1})}>Stock</Link>
                                        </Tab>
                                    </TabList>
                                    <div className="tab-content">
                                        <TabPanel className="tab-pane">
                                            <div className="panel-body">
                                                { this.props.product.get('_id')
                                                    ? <ProductDetail
                                                        mode={mode}
                                                        onChangeInput={ this.onChangeInput }
                                                        onChangeSupplierReference={ this.onChangeSupplierReference }
                                                        onChangeDefaultSupplier={ this.onChangeDefaultSupplier }
                                                        changeProductStatus={this.props.changeProductStatus}
                                                        addSupplier={ this.addSupplier }
                                                        deleteSupplier={ this.deleteSupplier }
                                                        deleteSuppliers={ this.deleteSuppliers }
                                                        product={{
                                                            _id: productId,
                                                            product_code,
                                                            name,
                                                            desc,
                                                            category_labels,
                                                            unit_of_measure,
                                                            vat,
                                                            to_buy,
                                                            is_generic,
                                                            suppliers,
                                                            cost_prices,
                                                            price_alert,
                                                            price_alert_threshold,
                                                            status
                                                        }}
                                                        newCategoryLabel={newCategoryLabel}
                                                        addCategoryLabel={ this.addCategoryLabel }
                                                        deleteCategoryLabel={ this.deleteCategoryLabel }
                                                    />
                                                    : null
                                                }
                                            </div>
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            <ProductStock
                                                productId={productId}
                                            />
                                        </TabPanel>
                                    </div>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const productReducer = state.products;

    // Product
    let product = productReducer.get('payload') || Map({});
    let projectionSuppliers = List([]);

    product.get('suppliers') && product.get('suppliers').map(supplier => {
        supplier = supplier.set('name', supplier.getIn(['supplier', 'basic_info', 'name']));
        supplier = supplier.set('supplier_code', supplier.getIn(['supplier', 'supplier_code']));
        return projectionSuppliers = projectionSuppliers.push(supplier);
    });
    product = product.set('suppliers', projectionSuppliers);

    return {
        product
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProduct: (productId, options) => dispatch(getProduct(productId, options)),
        updateProduct: (productId, product) => dispatch(updateProduct(productId, product)),
        changeProductStatus: (productId, status) => dispatch(changeProductStatus(productId, status)),
        deleteProduct: (productId) => dispatch(deleteProduct(productId)),
        cleanProducts: () => dispatch(cleanProducts())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductTabs);



// WEBPACK FOOTER //
// ./src/containers/configuration/products/ProductTabs.js